import React, { useEffect, useState } from 'react'
import axios from "axios";
import Config from "../../util/config";
import { Link } from 'react-router-dom';

const SearchArea = () => {

    const [articles, setArticles] = useState([]);
    const [article, setArticle] = useState({
        id: "",
        title: "",
        module_id: ""
    });
    const [flag, setFlag] = useState(false);

    const getAllArticles = () => {
        axios.get(Config.apiserver + "allarticle")
            .then(res => {
                console.log(res.data.data);
                setArticles(res.data.data);
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        getAllArticles()
    }, []);

    const handleSearch = (e) => {
        setFlag(true);
        // console.log(e);
        let value = e.target.value;

        const searchData = [];

        articles.map((item, i) => {
            if (item.title.toLowerCase().includes(value.toLowerCase())) {
                searchData.push({
                    id: item.id,
                    title: item.title,
                    module_id: item.module_id
                });
            }
        })
        searchData.length = 1;
        setArticle(searchData)
    }

    return (
        <>
            <section className="slice pt-6 pb-6 bg-dark">
                <img src="/images/searchbg.jpg" alt="CreativeItSoft" className="img-as-bg blend-mode--multiply" />
                <div data-offset-top="#navbar-main">
                    <div className="container d-flex align-items-center text-center text-lg-left">
                        <div className="col px-0">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 text-center">
                                    <h2 className="h1 text-white mb-2">Documentation</h2>
                                    {/*<form className="mt-2">*/}
                                    <div className="input-group input-group-lg mb-3">
                                        <input type="text" className="form-control" placeholder="Search" aria-label="Example text with button addon" aria-describedby="button-addon1" onChange={handleSearch} />
                                        <div className="input-group-append">
                                            <button className="btn btn-warning" type="button" id="button-addon1">Search</button>
                                        </div>
                                    </div>
                                    {
                                        flag === true && (
                                            <ul className="list-group">
                                                {
                                                    article.map((item, index) =>
                                                        <li className="list-group-item" key={index}><Link to={`/module/${item.module_id}`} >{item.title}</Link></li>
                                                    )
                                                }
                                            </ul>
                                        )
                                    }
                                    {/*</form>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default SearchArea
